import React, { type ChangeEventHandler } from "react";
import ReactToggle from "react-toggle";
import "react-toggle/style.css";
import "./Toggle.css";
import classNames from "classnames";

type Properties = {
    disabled?: boolean;
    className?: string;
    checked: boolean;
    defaultChecked?: boolean;
    onChange: ChangeEventHandler;
};

const Toggle = function Toggle({
    checked,
    className,
    defaultChecked,
    disabled = false,
    onChange,
}: Properties) {
    return (
        <ReactToggle
            className={classNames("toggle", className)}
            icons={false}
            disabled={disabled}
            checked={checked}
            defaultChecked={defaultChecked}
            onChange={onChange}
        />
    );
};

export default Toggle;
